export function getInstanceIdFromPath(): string | undefined {
  return window.location.pathname.match(/^\/([0-9a-f]{32})\b/)?.[1];
}
